import React from 'react';
import './credit.scss';

import CreditStore from './CreditStore';
import * as CreditConstants from './CreditConstants';
import * as CreditActions from './CreditActions';

import { withRouter } from 'react-router-dom';

import CreditApplicationStep1 from './components/CreditApplicationStep1';
import CreditApplicationStep2 from './components/CreditApplicationStep2';
import CreditApplicationStep3 from './components/CreditApplicationStep3';
import CreditApplicationStep4 from './components/CreditApplicationStep4';
import CreditApplicationStep5 from './components/CreditApplicationStep5';

import AppStore from 'AppStore';

class Credit extends React.Component {
    constructor(props) {
        super(props);
        this.onCreditChange = this.onCreditChange.bind(this);
        console.log(this.props);
        this.state = {
            creditState: CreditStore.getState(),
            quoteId: this.props.match.params.quoteId
        };
    }

    render() {
        const currentStep = this.getCurrentStep(this.state.creditState);
        console.log(currentStep);
        return (
            <div className="hack">
                <div id="app-container">
                    <div className="credit-container">{currentStep}</div>
                </div>
            </div>
        );
    }
    componentWillMount() {
        CreditStore.on('change', this.onCreditChange);
        CreditActions.goTo(CreditConstants.CREDIT_STEP1, {});
        this.profile = AppStore.getProfile();
        const user = AppStore.getUser();
        if (user && user.role !== 'vendor' && !this.state.quoteId) {
            alert('Create a quote to begin the credit application process');
            this.props.history.push('/quote');
        } else if (!this.profile) {
            this.props.history.push('/profile/credit/');
        }
    }

    componentWillUnmount() {
        CreditStore.removeListener('change', this.onCreditChange);
    }

    onCreditChange() {
        console.log('CREDIT STORE State', CreditStore.getState());
        this.setState({
            creditState: CreditStore.getState()
        });
    }

    getCurrentStep(state) {
        switch (state.state) {
            case CreditConstants.CREDIT_STEP1: {
                console.log('STEP 1');
                return (
                    <CreditApplicationStep1
                        credit={state}
                        quoteId={this.state.quoteId}
                    />
                );
            }
            case CreditConstants.CREDIT_STEP2: {
                return <CreditApplicationStep2 credit={state} />;
            }
            case CreditConstants.CREDIT_STEP3: {
                return <CreditApplicationStep3 credit={state} />;
            }
            case CreditConstants.CREDIT_STEP4: {
                return <CreditApplicationStep4 credit={state} />;
            }
            case CreditConstants.CREDIT_STEP5: {
                return <CreditApplicationStep5 credit={state} />;
            }
        }
    }
}

export default withRouter(Credit);



// WEBPACK FOOTER //
// ./src/app/pages/credit/Credit.jsx